import { render, staticRenderFns } from "./GlobalForms.vue?vue&type=template&id=767e8f46&scoped=true&"
import script from "./GlobalForms.vue?vue&type=script&lang=js&"
export * from "./GlobalForms.vue?vue&type=script&lang=js&"
import style0 from "./GlobalForms.vue?vue&type=style&index=0&id=767e8f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767e8f46",
  null
  
)

export default component.exports